import { useTheme } from 'next-themes';

export interface GraphTheme {
  bg: string;
  link: string;
  linkDim: string;
  border: string;
  text: string;
}

export function graphThemeFor(theme: 'light' | 'dark'): GraphTheme {
  return theme === 'light'
    ? {
        bg: '#FFFFFF',
        link: 'rgba(10,10,11,0.28)',
        linkDim: 'rgba(10,10,11,0.08)',
        border: 'rgba(10,10,11,0.18)',
        text: 'rgba(10,10,11,0.75)',
      }
    : {
        bg: '#0A0A0B',
        link: 'rgba(255,255,255,0.3)',
        linkDim: 'rgba(255,255,255,0.08)',
        border: 'rgba(255,255,255,0.22)',
        text: 'rgba(255,255,255,0.96)',
      };
}

export function useGraphTheme(): GraphTheme {
  const { resolvedTheme } = useTheme();
  return graphThemeFor(resolvedTheme === 'dark' ? 'dark' : 'light');
}
